import { logger } from '@/utils/logger/logger';

export const registerWavEncoder = async () => {
  const { connect } = await import('extendable-media-recorder-wav-encoder');
  const { register } = await import('extendable-media-recorder');
  // https://stackoverflow.com/questions/75600233/nextjs-blob-is-not-defined-when-using-npm-package-extendable-media-recorder-wa
  try {
    await register(await connect());
  } catch (error) {
    // Callers fire this unawaited at module scope (`audioRecorder` builds its
    // singleton on import), so the rejection can settle after a Jest worker
    // has torn its module registry down and nulled the logger's exports. An
    // uncaught TypeError there kills the whole worker; optional-calling keeps
    // production behaviour identical and turns that into a no-op.
    logger?.error?.(error);
  }
};

export const createExtendableMediaRecorder = async (
  stream: MediaStream,
  options: MediaRecorderOptions
) => {
  const { MediaRecorder } = await import('extendable-media-recorder');
  return new MediaRecorder(stream, options);
};
